"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trash = void 0;
exports.trash = {
    path: "M12.0834 2.5L12.9167 3.33333H15.8334V5H4.16669V3.33333H7.08335L7.91669 2.5H12.0834ZM5.00002 15.8333C5.00002 16.75 5.75002 17.5 6.66669 17.5H13.3334C14.25 17.5 15 16.75 15 15.8333V5.83333H5.00002V15.8333ZM6.66669 7.5H13.3334V15.8333H6.66669V7.5Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
